var exports = {
  "u": "xe7b6e3d6--dd4212--section",
};

module.exports = exports;
